import { z } from "zod";

export const UpdateCommentSchema = z.object({
    comment: z.string().min(1, "Comment is required").max(500, "Comment must be less than 500 characters"),
    user_id: z.nullable(z.string()).optional(),
})

export type UpdateCommentSchemaType = z.infer<typeof UpdateCommentSchema>;